module.exports = __webpack_public_path__ + "assets/img/euro-1.f402822f.svg";